import React from 'react';

export default function Privacy() {
  return (
    <div className="profile-section">
      <h3 className="profile-section-title">Privacy</h3>
      <p className="profile-description">
        Manage your data retention settings, privacy preferences, and GDPR options.
      </p>

      <div className="privacy-options">
        <div className="privacy-option">
          <div>
            <strong>Data Retention</strong>
            <p className="privacy-desc">Control how long your data is stored.</p>
          </div>
          <select className="auth-input" style={{ maxWidth: 180 }}>
            <option>1 year</option>
            <option>2 years</option>
            <option>5 years</option>
            <option>Indefinitely</option>
          </select>
        </div>

        <div className="privacy-option">
          <div>
            <strong>Analytics</strong>
            <p className="privacy-desc">Allow usage analytics to improve the platform.</p>
          </div>
          <label className="toggle-switch">
            <input type="checkbox" defaultChecked />
            <span className="toggle-slider" />
          </label>
        </div>

        <div className="privacy-option">
          <div>
            <strong>Marketing Emails</strong>
            <p className="privacy-desc">Receive updates and promotional emails.</p>
          </div>
          <label className="toggle-switch">
            <input type="checkbox" />
            <span className="toggle-slider" />
          </label>
        </div>
      </div>

      <div className="gdpr-actions">
        <button className="btn-secondary">Download My Data</button>
        <button className="btn-danger">Delete My Account</button>
      </div>
    </div>
  );
}
